/**
 * Google Sheets' official logomark — exact path data from Simple Icons
 * (simple-icons.org), the same source HubSpotIcon.tsx uses, so both connector
 * marks in the Connections page come from one place and are equally accurate.
 *
 * Kept as its own component and never re-coloured to the app's primary colour:
 * the mark identifies Google Sheets itself, not a Baatly-branded action, so it
 * is only ever shown at Google's own sheet green. The one exception is the
 * connect button, which passes `htmlColor="#fff"` to sit on a green fill —
 * exactly the pattern the HubSpot button already uses.
 */
import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const GOOGLE_SHEETS_GREEN = '#0F9D58';
/** Google's own hover/pressed shade for the same green. */
export const GOOGLE_SHEETS_GREEN_DARK = '#0B8043';

const GoogleSheetsIcon: React.FC<SvgIconProps> = ({ htmlColor, ...props }) => (
  <SvgIcon viewBox="0 0 24 24" htmlColor={htmlColor ?? GOOGLE_SHEETS_GREEN} {...props}>
    <path d="M11.318 12.545H7.91v-1.909h3.41v1.91zM14.728 0v6h6l-6-6zm1.363 10.636h-3.41v1.91h3.41v-1.91zm0 3.273h-3.41v1.91h3.41v-1.91zM20.727 6.5v15.864c0 .904-.732 1.636-1.636 1.636H4.909a1.636 1.636 0 0 1-1.636-1.636V1.636C3.273.732 4.005 0 4.909 0h9.318v6.5h6.5zm-3.273 2.773H6.545v7.909h10.91v-7.91zm-6.136 4.636H7.91v1.91h3.41v-1.91z" />
  </SvgIcon>
);

export default GoogleSheetsIcon;
